import React, { useState } from 'react';
import { useParams } from 'react-router-dom';  // useParamsを使用してURLパラメータを取得
import api from '../api/api';
import LoadingSpinner from '../utils/LoadingSpinner';

const PasswordResetDone = () => {
    const { uid, token } = useParams();  // URLからuidb64とtokenを取得
    const [newPassword1, setNewPassword1] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [showToLoginButton, setShowToLoginButton] = useState(false);

    const handleResetPassword = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const response = await api.post(`${process.env.REACT_APP_API_URL}/accounts/api/reset-change-password/`, { 
                uid,  // URLから取得したuidb64を送信
                token,   // URLから取得したtokenを送信
                new_password1: newPassword1,
                new_password2: newPassword2
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            setSuccess("パスワードが変更されました。");
            setShowToLoginButton(true);
        } catch (error) {
            if (error.response && error.response.data) {
                setError(error.response.data.new_password1 || error.response.data.new_password2 || "エラーが発生しました。");
            } else {
                setError("サーバーエラーが発生しました。");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='background'>
            <form method="post" className="form-main" onSubmit={handleResetPassword}>
                <h1>新しいパスワードの設定</h1>
                {error && <p style={{ color: 'red' }}>{error}</p>}
                {success && <p style={{ color: 'green' }}>{success}</p>}
                <label htmlFor="id_new_password1" className="password-reset-new-password">新しいパスワード:</label>
                <input
                    className="user-input"
                    type="password"
                    name="new_password1"
                    autoComplete="new-password"
                    required
                    id="id_new_password1"
                    value={newPassword1}
                    onChange={(e) => setNewPassword1(e.target.value)}
                />
                <br />
                <span className="helptext">
                    <ul>
                        <li>パスワードは最低 8 文字以上必要です。</li>
                        <li>数字だけのパスワードにはできません。</li>
                    </ul>
                </span>
                <label htmlFor="id_new_password2" className="password-reset-new-password">新しいパスワード(確認用):</label>
                <input
                    className="user-input"
                    type="password"
                    name="new_password2"
                    autoComplete="new-password"
                    required
                    id="id_new_password2"
                    value={newPassword2}
                    onChange={(e) => setNewPassword2(e.target.value)}
                />
                <br />
                {success ? 
                    (
                        <div>
                            <a href="/login" className="btn to-login-button">ログインページに戻る</a>
                        </div>
                    ) : (
                        loading ? 
                            <LoadingSpinner /> 
                        : 
                            <button type="submit" className="btn margin-bottom-20" disabled={loading}>
                                パスワードをリセット
                            </button>
                    )
                }
            </form>
        </div>
    );
};

export default PasswordResetDone;
